import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  quickTaskData: {},
  pageFlag: 'create'
}

export const quickTaskSlice = createSlice({
  name: 'quickTask',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setQuickTaskDataAction: (state, action) => {
      state.quickTaskData = action.payload
    },
    setQuickTaskPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setQuickTaskDataAction, setQuickTaskPageFlagAction } = quickTaskSlice.actions

// Selectors
export const selectQuickTaskData = (state) => state.quickTask.quickTaskData
export const selectQuickTaskPageFlag = (state) => state.quickTask.pageFlag

// Reducer
export default quickTaskSlice.reducer